export default __webpack_public_path__ + "static/media/pm.89241b46.svg";